import { makeAutoObservable } from 'mobx';
import { NEXT_BTN, PREVIOUS_BTN } from '../../../constants/constants';

export const ONBOARD_STEP_COUNT = 4;
const MAX_ONBOARD_STEP_INDEX = ONBOARD_STEP_COUNT - 1;

class NavigationStore {
	selectedPage = 0;

	constructor() {
		makeAutoObservable(this);
	}

	handlePageChange = (type, page, companyId, tab = null) => {
		if (type === NEXT_BTN.key) {
			this.selectedPage = Math.min(this.selectedPage + 1, MAX_ONBOARD_STEP_INDEX);
		} else if (type === PREVIOUS_BTN.key) {
			this.selectedPage = Math.max(this.selectedPage - 1, 0);
		} else {
			const targetPage = Number(page);
			this.selectedPage = Number.isNaN(targetPage) ? 0 : Math.min(Math.max(targetPage, 0), MAX_ONBOARD_STEP_INDEX);
		}

		const basePath = `/onboarding/${this.selectedPage}${companyId ? `/${companyId}` : ''}`;
		const urlWithTab = tab !== null && tab !== undefined && tab !== 0 ? `${basePath}?tab=${tab}` : basePath;
		window.history.replaceState(null, '', urlWithTab);
	};
}

export const navigationStore = new NavigationStore();
